import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import useAxios from "axios-hooks";
import ReportUsersTable from "../Components/ReportUsersTable";
import DeleteModal from "../../../../Util/DeleteModal";
import { Spinner } from "@fluentui/react";
import SuccessComponent from "../../../../Util/SuccessComponent";
import ErrorComponent from "../../../../Util/ErrorComponent";
import NoteComponent from "../../../../Util/NoteComponent";

const ReportUsersDefaultPage = () => {
    const history = useHistory();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState({ id: null, name: "" });
    const [errorMsg, setErrorMsg] = useState("");
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const [{ data: reportUsers, loading, error }, refetch] = useAxios(
        "/internal/reports-admin/users"
    );

    useEffect(() => {
        if (error) {
            setErrorMsg(
                "Failed to load report users. Please refresh the page and contact IT if the issue persists."
            );
            setShowError(true);
        }
    }, [error]);

    const handleEdit = (reportUserId) => {
        history.push(`/reporting/report-users/${reportUserId}/wizard`);
    };

    const handleCreate = () => {
        history.push("/reporting/report-users/wizard");
    };

    const handleDelete = (reportUserId, name) => {
        setDeleteTarget({ id: reportUserId, name });
        setShowDeleteModal(true);
    };

    if (loading) return <Spinner className="absolute-center" label="Loading Report Users..." />;

    return (
        <div>
            <h3>Report Users</h3>
            <SuccessComponent
                successMessage="Report User Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <ReportUsersTable
                reportUsers={reportUsers}
                setSelectedReportUser={_.noop}
                loading={loading}
                editOnClick={handleEdit}
                createOnClick={handleCreate}
                deleteOnClick={handleDelete}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={() => setShowDeleteModal((x) => !x)}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`internal/reports-admin/user/${deleteTarget.id}/`}
                resourceName={deleteTarget.name}
                resourceType="report user"
                confirmationValue={deleteTarget.name}
            />
            <NoteComponent
                isMultiline
                message="For the old reports site, this admin tool controls both user accounts and permissions. For the Client Console, this admin tool controls only permissions, while user accounts are managed by Auth0."
            />
        </div>
    );
};

export default ReportUsersDefaultPage;
